var blockedDates = [ 
  "2025-11-17",
  "2026-02-02",
  "2026-02-03",
  "2026-02-13",
  "2026-02-14",
  "2026-02-04",
  "2026-02-16",
  "2026-03-13",
  "2026-03-14",
  "2026-03-16",
  "2026-03-17",
  "2026-04-02",
  "2026-04-03",
  "2026-04-04",
  "2026-04-05",
  "2026-04-06",
  "2026-04-11",
  "2026-04-18",
  "2026-05-01",
  "2026-05-08",
  "2026-05-09",
  "2026-05-11",
  "2026-09-16",
  "2026-09-17",
  "2026-11-16",
  "2026-05-07",

];

var limitedTimeDates = [ 
  "2025-11-17",
  "2026-01-04",
  "2026-01-05",
  "2026-01-06",
  "2026-01-07",
  "2026-01-08",
  "2026-01-09",
  "2026-01-10",
  "2026-01-11",
  "2026-01-26",
  "2026-02-02",
  "2026-02-03",
  "2026-02-04",
  "2026-02-11",
  "2026-02-12",
  "2026-02-16",
  "2026-03-16",
  "2026-03-17",
  "2026-04-11",
  "2026-04-18",
  "2026-05-01",
  "2026-05-11",
  "2026-09-16",
  "2026-09-17",
  "2026-11-16",
  "2026-05-01",
];
